module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-en.jpg?fc1cc4b1";